var render, staticRenderFns
import script from "./AverageSalePriceTrends.vue?vue&type=script&lang=js&"
export * from "./AverageSalePriceTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e072c99')) {
      api.createRecord('5e072c99', component.options)
    } else {
      api.reload('5e072c99', component.options)
    }
    
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/trending-charts/AverageSalePriceTrends.vue"
export default component.exports